import Litepicker from 'litepicker';

const form = document.querySelector('.js-advanced-form');

let submit = null,
    nextStepBtns = null,
    formBlockHeadings = null,
    isGivingForm = false;

export function init() {
    if (!form) {
        return;
    }

    if (form.classList.contains('js-form-giving')) {
        isGivingForm = true;
    }

    submit = form.querySelector('button[type="submit"]').closest('[data-freeform-controls]');
    nextStepBtns = document.querySelectorAll(
        '.js-form-next-step, .js-advanced-form button[type="submit"]'
    );
    formBlockHeadings = document.querySelectorAll('.js-form-block-heading');

    // Build calendar
    const calendarEl = document.getElementById('form-calendar');

    if (calendarEl) {
        const calendar = new Litepicker({
            element: calendarEl,
            format: 'D MMM YYYY',
            inlineMode: true,
            singleMode: false,
            showTooltip: true,
            minDate: new Date(),
            setup: picker => {
                picker.on('selected', (startDate, endDate) => {
                    // Insert start and end dates into hidden input fields
                    document.querySelector(
                        'input[name="startDate"]'
                    ).value = startDate.toDateString();
                    document.querySelector('input[name="endDate"]').value = endDate.toDateString();
                });
            },
        });
    }

    // Update scroll offset for form
    form.addEventListener('freeform-ready', event => {
        // scrolling offset in pixels from the top of the form.
        // defaults to 0
        event.options.scrollOffset = -200;
    });

    // Do something on a successful ajax submit
    form.addEventListener('freeform-ajax-success', event => {
        // Redirect the user if this is the giving form and the donationFrequency is set to monthly
        if (event.response.finished && isGivingForm) {
            const frequency = document.querySelector('input[name="donationFrequency"]:checked');

            if (frequency && frequency.value === 'monthly') {
                // Redirect to donation endpoint so we can redirect to GoCardless
                window.location.href = `/donations/create?s=${event.response.submissionToken}`;
            }
        }
    });

    // Custom form error handling and placement
    form.addEventListener('freeform-render-form-errors', event => {
        event.preventDefault();

        const errors = event.errors,
            errorBlock = document.createElement('div'),
            paragraph = document.createElement('p');

        errorBlock.classList.add('ff-form-errors', 'ff-form-errors--mt');

        paragraph.appendChild(
            document.createTextNode(
                'The form contains some errors. Please check the fields and try again.'
            )
        );
        errorBlock.appendChild(paragraph);

        if (errors.length) {
            const errorsList = document.createElement('ul');

            for (let messageIndex = 0; messageIndex < errors.length; messageIndex++) {
                const message = errors[messageIndex],
                    listItem = document.createElement('li');

                listItem.appendChild(document.createTextNode(message));
                errorsList.appendChild(listItem);
            }

            errorBlock.appendChild(errorsList);
        }

        // Show errors just after submit button
        submit.after(errorBlock);
    });

    // Toggle showing/hiding block contents when clicking block heading
    formBlockHeadings.forEach(heading => {
        heading.addEventListener('click', e => {
            const block = heading.closest('.js-form-block');

            // Only allow toggling the block content display if the block isn't 'locked'
            if (!block.classList.contains('locked')) {
                block.classList.toggle('open');
            }
        });
    });

    // Process current block and open next form block when 'Next Step' button clicked
    nextStepBtns.forEach(btn => {
        if (form.hasAttribute('data-ajax') && btn.type === 'submit') {
            return;
        }

        btn.addEventListener('click', e => {
            const currentBlock = btn.closest('.js-form-block'),
                nextBlock = currentBlock.nextElementSibling;

            let fieldsValid = false;

            // Search for any block errors and remove them before validating the fields
            currentBlock.querySelectorAll('.form-block__error').forEach(el => {
                el.remove();
            });

            // Do validation checks on required fields in current block
            fieldsValid = validateBlockFields(currentBlock);

            if (fieldsValid) {
                // If the btn pressed is the submit button & the fields are valid, submit the form
                if (btn.type === 'submit') {
                    if (!isGivingForm) {
                        submit.querySelector('button[type="submit"]').classList.add('loading');
                        submit.querySelector('button[type="submit"]').disabled = true;
                    } else {
                        return false;
                    }
                } else {
                    // Not the submit button..timeline--complete
                    // Close current block content
                    currentBlock.classList.add('complete');
                    currentBlock.classList.remove('open');

                    // Open next block content
                    nextBlock.classList.remove('locked');
                    nextBlock.classList.add('open');

                    // Smooth scroll to the top of the newly opened block
                    const headerHeight = document.querySelector('.js-header').clientHeight;

                    // Delay the window scroll so it feels more intentional and less jumpy
                    setTimeout(() => {
                        window.scroll({
                            top: nextBlock.offsetTop - headerHeight - 30,
                            left: 0,
                            behavior: 'smooth',
                        });
                    }, 500);
                }
            } else {
                if (!isGivingForm) {
                    e.preventDefault();
                }

                // Validation errors in blok fields so show error
                const paragraph = document.createElement('p');

                paragraph.appendChild(
                    document.createTextNode(
                        'Please complete all required fields before moving to the next step.'
                    )
                );
                paragraph.classList.add('form-block__error');

                currentBlock.querySelector('.js-form-block-content').appendChild(paragraph);
            }
        });
    });
}

function validateBlockFields(block) {
    // Loop over all required fields
    for (const el of block.querySelectorAll('.js-required-field')) {
        // Find the field within and check that it has been filled/isn't empty etc
        for (const field of el.querySelectorAll('input, select, textarea')) {
            switch (field.tagName.toLowerCase()) {
                case 'textarea':
                case 'select':
                    if (!field.value) {
                        return false;
                    }

                    break;

                case 'input':
                    // Not a checkbox or radio input
                    if (!['checkbox', 'radio'].includes(field.type) && !field.value) {
                        return false;
                    }

                    if (['checkbox', 'radio'].includes(field.type)) {
                        let checked = false;

                        // Loop over all inputs with the same name as this field to see if any are checked
                        block.querySelectorAll(`input[name="${field.name}"]`).forEach(item => {
                            if (item.checked) {
                                checked = true;
                            }
                        });

                        if (!checked) {
                            return false;
                        }
                    }

                    break;
            }
        }
    }

    return true;
}
